export enum TaskConfigurationTypes {
  Single = 'single_task',
  UploadDocument = 'upload_document',
  SignDocuments = 'sign_documents',
  SendDocumentTemplate = 'send_document_template',
  DataCollection = 'data_collection',
}
